var map = {
	"./Alex.png": 45219,
	"./Damage-High.png": 41298,
	"./Damage-Low.png": 69243,
	"./Damage-Medium.png": 55751,
	"./Flower-Cyan.png": 66368,
	"./Flower-Poppy.png": 53937,
	"./Flower-Rose.png": 58436,
	"./SkinA.png": 99316,
	"./SkinS.png": 20868,
	"./Steve.png": 39653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15848;